import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {}
    transform(value: string) {
        if (typeof value === 'string') {
            value = value.replace(
                /target="_blank"/g,
                'target="_blank" rel="noopener noreferrer"'
            );
        }
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
